import styled from "styled-components";

import { QUERIES, SPACING, TOUCH_TARGET } from "../../../../../utils/constants";
import Button from "../../../../../components/Button";
import { SECTION_GAP } from "../../constants";

const STRIP_LINE_HEIGHT = 1.45;

// Cancels the touch target's height beyond one text line, so the strip doesn't grow to fit it.
const TOUCH_TARGET_OVERHANG = `calc((1em * ${STRIP_LINE_HEIGHT} - ${TOUCH_TARGET}px) / 2)`;

export const Strips = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  margin-top: ${SECTION_GAP}px;
`;

export const WarningStrip = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.sm + SPACING.xxs}px;
  padding: ${SPACING.sm + SPACING.xxs}px ${SPACING.sm + SPACING.xs}px;
  border: 1px solid var(--color-status-warning-border);
  border-radius: ${SPACING.sm}px;
  background: var(--color-status-warning-background);
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  line-height: ${STRIP_LINE_HEIGHT};

  > svg {
    flex-shrink: 0;
    margin-top: ${SPACING.xxs}px;
    font-size: var(--text-lg);
    color: var(--color-status-warning);
  }

  strong {
    color: var(--color-status-warning);
  }
`;

export const StripText = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const SetPriceButton = styled(Button)`
  margin-left: auto;

  @media ${QUERIES.tabletLargeAndDown} {
    min-width: ${TOUCH_TARGET}px;
    min-height: ${TOUCH_TARGET}px;
    margin-block: ${TOUCH_TARGET_OVERHANG};
  }
`;
